import Dashboard from "@/modules/dashboard/Dashboard.tsx";
import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/_main/")({
    component: Dashboard,
});
